"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrders = void 0;
const react_1 = require("react");
const context_1 = require("../context");
const graphql_1 = require("../graphql");
const address_1 = require("../helpers/address");
const delay_1 = require("../helpers/delay");
const types_1 = require("../types");
const cart_1 = require("../types/cart");
const navbar_1 = require("../types/navbar");
const useOrders = ({ orderVersion = "V1", }) => {
    // order version
    // V1 - bydefault
    // V2 - "shipping" will be based on coupon and excludes prepaid discount and cod charges while calculating shipping charges
    // const { success } = useInventory();
    const { resolve, cartItems, appliedCoupon, storeId, user, isReady } = (0, context_1.useNavbar)();
    const [order, setOrder] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const isConfirmed = !!((order === null || order === void 0 ? void 0 : order.status) === types_1.OrderStatus.CONFIRMED && order.code);
    const reset = () => {
        setLoading(false);
        setOrder(null);
    };
    const placeOrder = async (params) => {
        if (!isReady) {
            return {
                success: false,
                code: "NOT_READY",
                error: "Try again in sometime...",
            };
        }
        const { paymentMethod, address, metadata, appliedRewardPoints, totalAmount, shoppingCartId, isAffiseTrackingValid, totalCashbackEarned, source, } = params;
        setLoading(true);
        // if (!success) {
        //   setLoading(false);
        //   return {
        //     success: false,
        //     code: "INVENTORY_MISMATCH",
        //   };
        // }
        if (paymentMethod === cart_1.InternalPaymentType.NONE) {
            setLoading(false);
            return {
                success: false,
                code: "INVALID_PAYMENT_METHOD",
            };
        }
        const formErrors = await (0, address_1.validateAddress)(address, paymentMethod, {
            resolve,
        });
        if (formErrors) {
            setLoading(false);
            return {
                success: false,
                code: "INVALID_ADDRESS",
                formError: formErrors,
            };
        }
        const authMode = !!user && !!(user === null || user === void 0 ? void 0 : user.id) ? navbar_1.AuthMode.AUTH : navbar_1.AuthMode.API_KEY;
        try {
            const tempAddress = (0, address_1.getProperAddress)(address);
            const { id: ignoreId } = tempAddress, restAddress = __rest(tempAddress, ["id"]);
            const productIds = cartItems
                .filter((p) => p.cartItemSource !== cart_1.CartItemSource.COUPON)
                .map(({ id, variantId, qty, cartItemSource: source = null }) => ({
                productId: id,
                variantId,
                quantity: Number(qty),
                source,
            }));
            const payload = Object.assign(Object.assign({ products: productIds, shippingAddress: restAddress, billingAddress: restAddress, couponCode: appliedCoupon === null || appliedCoupon === void 0 ? void 0 : appliedCoupon.code, storeId, paymentType: paymentMethod, appliedRewardPoints,
                totalAmount,
                shoppingCartId,
                isAffiseTrackingValid,
                source,
                totalCashbackEarned }, metadata), { orderVersion });
            const newOrder = await resolve(graphql_1.createOrder, { input: payload }, authMode).then((resp) => resp.data.createOrder);
            const payments = await resolve(graphql_1.byorderIdcreatedAtPayment, { orderId: newOrder.id }, authMode).then((resp) => resp.data.byorderIdcreatedAtPayment.items.filter((payment) => payment.method !== types_1.PaymentMethod.CASHBACK));
            const newPayment = payments.find((p) => p.method === "ONLINE");
            let transaction = null;
            if (newOrder.paymentType !== types_1.PaymentType.COD) {
                transaction = await resolve(graphql_1.createTransaction, { orderId: newOrder.id }, authMode).then((resp) => resp.data.createTransaction);
            }
            if (newOrder.paymentType === types_1.PaymentType.COD) {
                fetchOrderStatus(newOrder.id);
            }
            setLoading(false);
            return {
                success: true,
                order: newOrder,
                payment: newPayment,
                transaction,
            };
        }
        catch (error) {
            setLoading(false);
            return { success: false, code: "ERROR", error: error.message };
        }
    };
    const fetchOrderStatus = async (orderId) => {
        if (!isConfirmed) {
            setLoading(true);
            const confimedOrder = await resolve(graphql_1.getOrderStatus, { id: orderId }).then((resp) => !!resp.data.getOrder.code &&
                resp.data.getOrder.status === types_1.OrderStatus.CONFIRMED
                ? resp.data.getOrder
                : null);
            if (confimedOrder) {
                setOrder(confimedOrder);
            }
            else {
                await (0, delay_1.delay)(2000);
                fetchOrderStatus(orderId);
            }
        }
    };
    const fetchTransactionStatus = async (orderId, razorpayPaymentId) => {
        setLoading(true);
        const checkIsConfirmed = await resolve(graphql_1.validateTransaction, {
            orderId,
            razorpayPaymentId,
        }).then((resp) => !!resp.data.validateTransaction.success);
        if (checkIsConfirmed) {
            fetchOrderStatus(orderId);
            return true;
        }
        else {
            await (0, delay_1.delay)(2000);
            fetchTransactionStatus(orderId, razorpayPaymentId);
        }
        return false;
    };
    return [
        { order, loading, isConfirmed },
        placeOrder,
        {
            fetchTransactionStatus,
            reset,
        },
    ];
};
exports.useOrders = useOrders;
